<template>
  <div class="container-fluid">
    <div class="card card-default">
      <div class="card-header feature-header">
        <div class="row">
          <div class="col-auto me-auto">
            <card-title-component />
          </div>
          <div class="col-auto">
            <SearchComponent v-model="searchText" @search="onSearch" @clear="clearSearch" />
          </div>
          <div class="col-auto">
            <a class="btn btn-outline-primary" @click="open()">
              <i class="fas fa-plus me-1"></i>{{ $t("addNew") }}
            </a>
          </div>
        </div>
      </div>
      <div class="card-body p-2">
        <div class="card-body-grid">
          <ejs-grid ref="gridPage" :dataSource="data" :allowPaging="true" :allowResizing="true"
            :pageSettings="pageSettings" :locale="locale" :rowHeight="38" height="100%" :allowSorting="true"
            :searchSettings="searchOptions" :dataStateChange="dataStateChange">
            <e-columns>
              <e-column :headerText="$t('title')" field="Title"></e-column>
              <e-column :headerText="$t('url')" field="Url"></e-column>
              <e-column :headerText="$t('icon')" field="Icon"></e-column>
              <e-column :headerText="$t('subscriber') + ' ' + $t('type')" field="SubscriberType"></e-column>
              <e-column :headerText="$t('module')" field="Module"></e-column>
              <e-column :headerText="$t('ordinal')" field="Ordinal"></e-column>
              <e-column :headerText="$t('actions')" width="75" textAlign="Center" :template="'actionTemplate'">
                <template v-slot:actionTemplate="{ data }">
                  <div class="btn-group actions-row" role="group" aria-label="Basic example">
                    <a href="javascript:void(0)" class="ms-2 action-link action-edit" title="Edit"
                      @click="commandClick('Edit', data)">
                      <i class="e-edit e-icons" style="font-size: 0.76em;"></i>
                    </a>
                    <a href="javascript:void(0)" class="ms-2 action-link action-delete" title="Delete"
                      @click="commandClick('Delete', data)">
                      <i class="e-delete e-icons" style="font-size: 0.76em;"></i>
                    </a>
                  </div>
                </template>
              </e-column>
            </e-columns>
          </ejs-grid>
        </div>
      </div>
    </div>
  </div>
  <div class="modal fade" id="PageModal" Page="dialog">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title">{{ $t("page") }}</h4>
          <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close" @click="close()">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <form @submit="onUpsert">
          <div class="modal-body">
            <div class="row">
              <div class="col-md-6">
                <div class="form-group">
                  <label>{{ $t("module") }}</label>
                  <ejs-dropdownlist :id="'moduleTree'" v-model="form.moduleId" :dataSource="module.data"
                    :fields="module.fields">
                  </ejs-dropdownlist>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <label>{{ $t("subscriber") + " " + $t("type") }}
                    <span class="text-danger">*</span></label>
                  <ejs-dropdownlist :id="'subscriberType'" v-model="form.subscriberType"
                    :dataSource="subscriberType.data" :fields="subscriberType.fields">
                  </ejs-dropdownlist>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <div class="form-group">
                  <label>{{ $t("title") }} <span class="text-danger">*</span></label>
                  <input type="text" class="form-control input-sm" v-model="form.title" required />
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <label>{{ $t("icon") }} <span class="text-danger">*</span></label>
                  <input type="text" class="form-control input-sm" v-model="form.icon" />
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-md-6">
                <div class="form-group">
                  <label>{{ $t("url") }}</label>
                  <input type="text" class="form-control input-sm" v-model="form.url" />
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <label>{{ $t("ordinal") }}
                    <span class="text-danger">*</span></label>
                  <input type="number" class="form-control input-sm" style="text-align: right" id="parent"
                    v-model="form.ordinal" />
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <div class="form-group">
                  <label>{{ $t("extraUrls") }}</label><span class="badge">({{ $t("commaSeparatedUrls") }})</span>
                  <input type="text" class="form-control input-sm" v-model="form.extraUrl" />
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <div class="form-group mt-2 d-flex align-items-center gap-2">
                  <input type="checkbox" id="isParent" class="checkbox" @change="chkIsParentChange" v-model="form.isParent" />
                  <label for="isParent" class="mb-0">{{ $t("parent") }}</label>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group mt-2 d-flex align-items-center gap-2">
                  <input type="checkbox" id="IsActive" class="checkbox" v-model="form.isActive" />
                  <label for="IsActive" class="mb-0">{{ $t("active") }}</label>
                </div>
              </div>
            </div>

            <div class="row" v-if="!form.isParent">
              <div class="col-md-12">
                <div class="form-group">
                  <label>{{ $t("parent") }}
                    <span class="text-danger">*</span></label>
                  <ejs-dropdownlist :id="'parentTree'" v-model="form.parentId" :dataSource="parentPage.data"
                    cssClass="drop-down-text" :fields="parentPage.fields">
                  </ejs-dropdownlist>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-sm btn-outline-close" @click="close()">
              <i class="fas fa-times"></i>&nbsp;{{ $t("close") }}
            </button>
            <button type="submit" class="btn btn-sm btn-outline-info-reverse">
              <i class="fas fa-save"></i>&nbsp;{{ isUpdate ? $t("update") : $t("save") }}
            </button>
          </div>
        </form>
      </div>
      <!-- /.modal-content -->
    </div>
    <!-- /.modal-dialog -->
  </div>
</template>

<script lang="ts">
import './PageComponent.css';
import modal from "@/components/common/modalManage";
import agent, { masterServiceBaseURL } from "@/services/agent";
import authService from "@/services/authService";
import toasterService from "@/services/toasterService";
import { L10n, setCulture } from "@syncfusion/ej2-base";
import { DropDownListComponent } from "@syncfusion/ej2-vue-dropdowns";
import {
  ColumnDirective as EColumn,
  ColumnsDirective as EColumns,
  GridComponent as EjsGrid,
  Freeze,
  Group,
  Page,
  Resize,
  Sort,
  Toolbar,
} from "@syncfusion/ej2-vue-grids";
import { DialogUtility } from "@syncfusion/ej2-vue-popups";
import { defineComponent } from "vue";
import SubsriberType from "../../common/SubsriberTypeEnum";
import { Module, ModuleGetResponse } from "../Module/Module.model";
import { Subscription } from "../Subscription/Subscription.model";
import { SubscriptionGetResponse } from "../User/User.model";
import { API_KEY, TABLE_SETTINGS } from "./constants";
import {
  GetParentPageResponse,
  PageForm,
  PageFormGetResponse,
  PageFormResponse,
  Property,
} from "./Page.model";
import emitter from "@/services/mitt";
import CardTitleComponent from '@/components/common/CardTitleComponent.vue';
import SearchComponent from '@/components/shared/SearchComponent.vue';

let Confirmation: any = undefined;

export default defineComponent({
  components: {
    "ejs-grid": EjsGrid,
    "e-columns": EColumns,
    "e-column": EColumn,
    "ejs-dropdownlist": DropDownListComponent,
    CardTitleComponent,
    SearchComponent,
  },
  provide: {
    grid: [Toolbar, Resize, Page, Sort, Group, Freeze],
  },
  created() {
    agent.setBaseUrl(masterServiceBaseURL);

    this.gridLocalize();
  },
  data() {
    return {
      listSubscription: [] as Subscription[],
      data: {} as Property,
      form: {} as PageForm,
      isUpdate: false,
      selectedState: null,
      searchText: '',
      searchOptions: TABLE_SETTINGS.SEARCH_OPTIONS,
      pageSettings: TABLE_SETTINGS.PAGE_SETTINGS,
      module: {
        data: [] as Module[],
        fields: { text: "displayName", value: "id" },
      },
      parentPage: {
        data: [] as any[],
        fields: { text: "title", value: "id" },
      },
      subscriberType: {
        data: [SubsriberType.Host, SubsriberType.Tenant],
        fields: { text: "name", value: "name" },
      },
      locale: "",
    };
  },
  async mounted() {
    this.resetPage();
    this.dataStateChange(
      this.initState(this.pageSettings.state)
    );
    await this.loadModule();
    await this.loadSubscription();
    await this.loadParentPages();
  },
  unmounted() {
    this.pageSettings.state = {
      skip: TABLE_SETTINGS.PAGE_SETTINGS.state.skip,
      take: TABLE_SETTINGS.PAGE_SETTINGS.state.take,
    } as any
  },
  methods: {
    initState(params: any): any {
      const state = {
        ...params
      };
      return state;
    },
    dataStateChange(state: any) {
      this.pageSettings.state = state;
      this.gridLocalize();
      this.loadPage(state);
    },
    chkIsParentChange() {
      if (this.form.isParent) {
        this.form.parentId = null;
      }
    },
    async loadParentPages() {
      const response = await agent.get<GetParentPageResponse>(
        API_KEY.GET_PARENTS
      );
      if (response && response.result) {
        this.parentPage.data = response.result;
      }
    },
    async loadPage(state: any) {
      if (state.action) {
        delete state.action;
      }

      const gridPage: any = this.$refs.gridPage;
      if (gridPage) gridPage.hideSpinner();

      const response = await agent.post<PageFormGetResponse>(
        API_KEY.GET_PAGES,
        state
      );
      if (response && response.result) {
        this.data = response.result;
      }
    },
    async loadModule() {
      const response = await agent.post<ModuleGetResponse>(
        API_KEY.GET_MODULES,
        {}
      );
      if (response && response.result) {
        this.module.data = [
          {
            id: 0,
            displayName: this.$t("root"),
          } as Module,
          ...response.result.result,
        ];
      }
    },
    async loadSubscription() {
      const response = await agent.post<SubscriptionGetResponse>(
        API_KEY.GET_SUBSCRIPTIONS,
        {}
      );
      if (response && response.result) {
        this.listSubscription = response.result.result;
      }
    },
    onUpsert(event: any) {
      event.preventDefault();

      if (this.isUpdate) {
        this.onEdit();
      } else {
        this.onSave();
      }
    },
    async onSave() {
      let post = { ...this.form };
      post.createdBy = authService.getUserEmail();

      if (post.isParent) post.parentId = undefined;

      post.subscriberType = String(post.subscriberType);

      const response = await agent.post<PageFormResponse>(API_KEY.POST, post);
      if (response && response.result) {
        toasterService.success(this.$t("msgSave"));
        this.loadPage(
          this.initState(this.pageSettings.state)
        );
        this.resetPage();
        this.close();
        this.loadParentPages();
        emitter.emit('update-permission', {});
      }
    },
    async onEdit() {
      let put = { ...this.form };

      put.modifiedBy = authService.getUserEmail();

      if (put.isParent) put.parentId = undefined;

      put.subscriberType = String(put.subscriberType);

      const response = await agent.put<PageFormResponse>(API_KEY.PUT, put);
      if (response && response.result) {
        toasterService.success(this.$t("msgUpdate"));
        this.loadPage(
          this.initState(this.pageSettings.state)
        );
        this.resetPage();
        this.close();
        this.loadParentPages();
        emitter.emit('update-permission', {});
      }
    },
    async onDelete(id: number) {
      const response = await agent.delete<PageFormResponse>(`v1/page/${id}`);
      if (response && response.result) {
        toasterService.success(this.$t("msgDelete"));
        this.loadPage(
          this.initState(this.pageSettings.state)
        );
        this.resetPage();
        this.loadParentPages();
        emitter.emit('update-permission', {});
      }
    },
    resetPage() {
      this.form = {} as PageForm;
      this.form.parentId = null;
      this.form.isParent = true;
      this.form.isActive = true;
      this.form.moduleId = 0;
      this.isUpdate = false;
      this.form.subscriberType = SubsriberType.Tenant.name;
    },
    gridLocalize() {
      this.locale = "en-grid";
      if (this.$i18n.locale == "se") {
        setTimeout(() => {
          import(`@/assets/sv.json`).then((module) => {
            const localText = module.default;
            this.locale = "sv";
            setCulture("sv");
            L10n.load(localText);
          });
        });
      }
    },

    commandClick: function (type: string, data: any) {
      this.isUpdate = false;
      const app = this;
      switch (type) {
        case "Delete":
          this.form.id = data.id;
          Confirmation = DialogUtility.confirm({
            title: this.$t("deleteConfiramtion"),
            content: this.$t("msgSureWantToDelete"),
            okButton: {
              text: this.$t("ok"),
              click: async function () {
                Confirmation.hide();
                app.onDelete(app.form.id);
              },
            },
            cancelButton: { text: this.$t("cancel") },
            showCloseIcon: true,
            closeOnEscape: true,
            zIndex: 10000,
            animationSettings: { effect: "Zoom" },
          });
          break;
        case "Edit":
          this.form = data;
          this.isUpdate = true;
          modal.Open("PageModal");
          break;
        default:
          break;
      }
    },
    open() {
      modal.Open("PageModal");
    },
    close() {
      this.resetPage();
      modal.Close("PageModal");
    },
    onSearch() {
      const grid = (this.$refs.gridPage as any)?.ej2Instances;
      if (grid) grid.search(this.searchText);
    },
    clearSearch() {
      this.searchText = '';
      const grid = (this.$refs.gridPage as any)?.ej2Instances;
      if (grid) grid.search('');
    },
  },
});
</script>
